import React from 'react';

import { FeatureCategories } from 'src/modules/designStudio/constants';
import { DesignConfig } from 'src/modules/designStudio/types';

import { UpdateDesignFunction } from '../../../providers/HistoryProvider';
import { ColorList } from '../Filters/ColorList';

export const TrimMenu = ({
  designConfig,
  updateDesign,
}: {
  designConfig: DesignConfig;
  updateDesign: UpdateDesignFunction;
}) => {
  const { color } = designConfig[FeatureCategories.TRIM];

  return (
    <ColorList
      color={color}
      designConfig={designConfig}
      designConfigCategory={FeatureCategories.TRIM}
      updateDesign={updateDesign}
    />
  );
};
